'use strict';

const moment = require('moment');

function getDateRange(from, to) {
	return from && to
		? {
				from,
				to
			}
		: null;
}

function makeProducts (auth) {
	return {
		listenAndRespond: {
			enabled: auth.user?.selectedSite?.listenRespond?.enabled || false,
		},
		socialMedia: {
			enabled: auth.user?.selectedSite?.socialMedia?.locationPost?.enabled || false,
		}
	}
}

const insightsRatingResolver = async (
	$stateParams,
	pmtUtilService,
	pmtEnvService,
	pmtFilterService,
	auth
) => {
	return {
		siteName: $stateParams.site || $stateParams.siteName,
		initialFilter: await pmtFilterService.parseFilter($stateParams),
		view: $stateParams.view ? $stateParams.view : null,
		dateRange: getDateRange($stateParams.from, $stateParams.to),
		requestUrl: pmtEnvService.insightsApiUrl,
		today: new Date().toISOString(),
		baseUrl: pmtEnvService.listingsManagerUrl,
		placeId: $stateParams.placeId || null,
		language: pmtUtilService.getByPath(['settings', 'language', auth.user]) || '',
		locale: pmtUtilService.getByPath(['settings', 'locale', auth.user]) || '',
		listenRespondEnabled:
			pmtUtilService.getByPath(['selectedSite', 'listenRespond', 'enabled'], auth.user) || false
	};
};

const makeBaseInsightsArgsResolver = async (pmtEnvService, $stateParams, pmtFilterService) => ({
	siteName: $stateParams.site || $stateParams.siteName,
	today: new Date().toISOString(),
	dateRange: getDateRange($stateParams.from, $stateParams.to),
	insightsUrl: pmtEnvService.insightsApiUrl,
	baseUrl: pmtEnvService.listingsManagerUrl,
	startOfMonth: moment().utc().startOf('month').valueOf(),
	timezoneOffset: new Date().getTimezoneOffset() * -1,
	placeId: $stateParams.placeId || null,
	...(pmtFilterService && { initialFilter: await pmtFilterService.parseFilter($stateParams) })
});

const googleInsightsArgsResolver = makeBaseInsightsArgsResolver;
const overviewInsightsArgsResolver = async (
	pmtEnvService,
	$stateParams,
	pmtFilterService,
	auth
) => ({
	...(await makeBaseInsightsArgsResolver(pmtEnvService, $stateParams, pmtFilterService)),
	analytics: auth.user?.selectedSite?.analytics
});

const bingInsightsArgsResolver = makeBaseInsightsArgsResolver;
const appleInsightsArgsResolver = async (pmtEnvService, $stateParams, pmtFilterService, auth) => ({
	...(await makeBaseInsightsArgsResolver(pmtEnvService, $stateParams, pmtFilterService)),
	appleConnectionType: auth.user?.selectedSite?.analytics?.apple?.connectionType || 'system'
});

const googleKeywordsInsightsArgsResolver = async (pmtEnvService, $stateParams) => ({
	...(await makeBaseInsightsArgsResolver(pmtEnvService, $stateParams)),
	startOfMonth: moment().utc().startOf('month').format('YYYY-MM-DD'),
	placeId: $stateParams.placeId || null
});

const ratingInsightsArgsResolver = async (
	pmtEnvService,
	$stateParams,
	pmtFilterService,
	auth
) => ({
	...(await makeBaseInsightsArgsResolver(pmtEnvService, $stateParams, pmtFilterService)),
	analytics: auth.user?.selectedSite?.analytics,
	products: makeProducts(auth)
});

module.exports = {
	insightsRatingResolver,
	googleInsightsArgsResolver,
	googleKeywordsInsightsArgsResolver,
	appleInsightsArgsResolver,
	bingInsightsArgsResolver,
	overviewInsightsArgsResolver,
	ratingInsightsArgsResolver
};
